module.exports = __webpack_public_path__ + "static/media/3izone.817a1ef8.png";